export const vehicleDefaultValues = {
  vehicles: [],
  vehiclesAvailable: 0,
};
